<template>
  <div v-if="itemsLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="project-details-page">
    <vue-headful :title="getTitleSeo()" :description="getDescSeo()" :keywords="getKeywordsSeo()" />

    <Banner class="project-details-hero" :classes="'page-header-bg'" :background="item.image ? item.image.url : ''"
      :title="!itemsLoading ? row.title : ''" :subtitle="!itemsLoading ? row.main_category.name : ''" :redirectTo2="!itemsLoading ? '/projects-list/' + row.main_category.id : ''
        ">
    </Banner>

    <section class="cases-details-area pt-50">
      <div class="container">
        <div class="row project-details-grid">
          <div class="col-xl-8 col-lg-8 col-md-12 project-content-column">
            <div class="details-left-area pb-50">
              <div class="cases cases-wrapper-box wow fadeInUp2 animated" data-wow-delay=".2s">
                <div class="cases__content">
                  <div class="cases__box mb-40 project-media">
                    <div v-if="(!galleries || !galleries.length) && !row.image"
                      class="Home-slider-slide item pos-rel d-flex align-items-center" style="
                        background-image: url('/assets/img/logo/min-logo.png');
                        height: 192px;
                      "></div>
                    <div v-if="(!galleries || !galleries.length) && row.image"
                      class="Home-slider-slide item pos-rel d-flex align-items-center" :style="'background-image: url(' + row.image
                          ? row.image.url
                          : '/assets/img/logo/min-logo.png' +
                          ');height:500px:width: 500px; background-size: 100% 100%'
                        "></div>

                    <carousel class="home-main-carousel moving-waves" v-if="!itemsLoading && galleries"
                      :rtl="$i18n.locale == 'ar' ? true : false" :autoplay="true" :items="1" :nav="true" :dots="false"
                      :navText="[
                        `<i class='fa fa-angle-right'></i>`,
                        `<i class='fa fa-angle-left'></i>`,
                      ]">
                      <div v-for="(item, idx) in galleries" :key="idx">
                        <div v-if="item.image_url"
                          class="Home-slider-slide item single-slider pos-rel d-flex align-items-center" :style="'background-image: url(' + item.image_url + ')'
                            "></div>
                        <iframe v-if="item.video_url"
                          class="Home-slider-slide item single-slider pos-rel d-flex align-items-center"
                          style="height: 430px" :src="item.video_url">
                        </iframe>
                      </div>
                    </carousel>
                  </div>

                  <h2 class="single-case-details-title">
                    {{ row.title }}
                  </h2>

                  <div class="cases--author d-flex align-items-center mb-25">
                    <flag v-if="row.country" :iso="row.country.ccode" style="font-size: 35px; border-radius: 50%" />
                    <div class="mx-2 align-items-start">
                      <h4 class="semi-02-title m-0">
                        {{ row.country ? row.country.name : "" }}
                      </h4>
                      <span>
                        <!-- <strong>خيري</strong> -  -->

                        {{ $t("app.target") }} {{ row.target }}
                        {{ $t("app.kwd") }}</span>
                    </div>
                  </div>

                  <div v-if="row.allow_progress_bar" class="cases-meta">
                    <div class="cases-progress">
                      <div class="project-progress-track">
                        <div class="progress">
                          <div class="progress-bar wow fadeInLeft animated" data-wow-delay="0.3s" role="progressbar"
                            style="height: 7px" :style="'width:' + row.percentage + '%'" :aria-valuenow="row.percentage"
                            aria-valuemin="0" aria-valuemax="100">
                          </div>
                        </div>
                        <h3>{{ row.percentage }}%</h3>
                      </div>
                      <div class="project-financial-summary">
                        <div>
                          <span>{{ $t("app.target") }}</span>
                          <strong>{{ row.target }} {{ $t("app.kwd") }}</strong>
                        </div>
                        <h4 class="funding semi-02-title">
                          {{ $t("app.collect") }}
                          <span>{{ row.paid }} {{ $t("app.dinar") }}</span>
                        </h4>
                        <div>
                          <span>{{ $t("app.remainMoney") }}</span>
                          <strong>{{ row.remain }} {{ $t("app.kwd") }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Mobile-only Donation Form (d-lg-none) -->
              <div class="col-xl-4 col-lg-4 col-md-12 d-block d-lg-none mb-10 mt-20 project-donation-mobile">
                <div class="details-right-area">
                  <div class="widget grey-bg2 mb-30" style="padding: 0 !important">
                    <div class="widget-post cases-information" id="donate-m">
                      <div class="doante-select-area mt-0">
                        <div class="self-donation">
                          <div class="donation-form-left">
                            <div class="doante-select-area" style="padding: 20px; padding-top: 0">
                              <h3 class="cases-title mb-30">
                                {{ $t("app.donation_values") }}
                              </h3>
                              <div class="input-donate">
                                <button class="cont_btn" :style="$i18n.locale == 'ar'
                                    ? 'font-size:16px'
                                    : 'font-size:13px'
                                  " v-for="(row, index) in values" :key="index" @click="changeAmount(index, row)"
                                  :class="amount == row && !custom_amount.length
                                      ? 'active'
                                      : ''
                                    ">
                                  {{ row }}
                                  <span class="usd" v-if="locale == 'ar'">{{
                                    currency == "KWD" ? "د.ك" : "ريال"
                                  }}</span>
                                  <span class="usd" v-else>{{
                                    currency == "SAR" ? "SAR" : "KWD"
                                  }}</span>
                                </button>
                              </div>

                              <h6 v-if="row.allow_donate_other_amount" class="text-center my-4">
                                {{ $t("app.enter_Amount") }}
                              </h6>

                              <div v-if="row.allow_donate_other_amount" class="donate-cart pos-rel">
                                <form class="donate-btn pos-rel">
                                  <input type="number" min="1" class="input-donat" v-model="custom_amount"
                                    :placeholder="$t('app.enter_amount')" />
                                </form>
                                <div class="plus-minus">
                                  <div :style="[
                                    locale == 'ar'
                                      ? { right: '0px' }
                                      : { left: '0px' },
                                  ]" class="cart inc">
                                    <i style="padding: 25px" :class="[
                                      locale == 'ar'
                                        ? 'far fa-chevron-right'
                                        : 'far fa-chevron-left',
                                    ]" @click="incrementCustomAmount()"></i>
                                  </div>
                                  <div :style="[
                                    locale == 'ar'
                                      ? { left: '0px' }
                                      : { right: '0px' },
                                  ]" class="cart dec">
                                    <i style="padding: 25px" :class="[
                                      locale == 'ar'
                                        ? 'far fa-chevron-left'
                                        : 'far fa-chevron-right',
                                    ]" @click="decrementCustomAmount()"></i>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="donar-information donation-form white-bg mb-10">
                              <div class="section-title text-left mb-50">
                                <h2 :style="$i18n.locale == 'en'
                                    ? 'text-align:left !important'
                                    : ''
                                  ">
                                  {{ $t("cart.payment_method") }}
                                </h2>
                              </div>
                              <div class="cc-selector row">
                                <div class="col-4 col-md-3" v-for="method in paymentMethods"
                                  :key="method.PaymentMethodId" style="display: inline-block; margin: 5px">
                                  <input :id="'payment_m_' + method.PaymentMethodId" type="radio"
                                    :value="method.PaymentMethodId" :checked="payment_method == method.PaymentMethodId
                                        ? true
                                        : false
                                      " @change="
                                      pamyentMethod(method.PaymentMethodId)
                                      " name="payment_method_m" />
                                  <label class="payment-item" :for="'payment_m_' + method.PaymentMethodId">
                                    <img :src="method.ImageUrl" width="50px" loading="lazy"
                                      :alt="method.PaymentMethodEn" />
                                    <span class="payment-method-name">
                                      {{
                                        $i18n.locale == "ar"
                                          ? method.PaymentMethodAr
                                          : method.PaymentMethodEn
                                      }}
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div class="donar-information donation-form white-bg">
                              <div class="section-title text-left mb-50">
                                <h2 :style="$i18n.locale == 'en'
                                    ? 'text-align:left !important'
                                    : ''
                                  ">
                                  {{ $t("cart.donation_info") }}
                                </h2>
                              </div>
                              <ul class="nav nav-tabs mb-15" id="myTab-m" role="tablist">
                                <li class="nav-item">
                                  <a class="nav-link active" id="home-tab-m" data-toggle="tab" href="#home-m" role="tab"
                                    aria-controls="home-m" aria-selected="true">{{ $t("cart.donation_info") }}</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="profile-tab-m" data-toggle="tab" href="#profile-m" role="tab"
                                    aria-controls="profile-m" aria-selected="false">{{ $t("cart.good_man") }}</a>
                                </li>
                              </ul>
                              <div class="tab-content" id="myTabContent-m">
                                <div class="tab-pane fade show active" id="home-m" role="tabpanel"
                                  aria-labelledby="home-tab-m">
                                  <div class="row payment-inner">
                                    <form action="#">
                                      <div class="row">
                                        <div class="col-xl-12">
                                          <div class="input-area mb-30">
                                            <input type="text" class="form-control" v-model="row.name"
                                              :placeholder="$t('contact.name')" />
                                          </div>
                                        </div>
                                        <div class="col-xl-12">
                                          <div class="input-area mb-30">
                                            <vue-tel-input class="form-control" v-model="row.mobile" :placeholder="$t('contact.mobile')
                                              " :defaultCountry="'KW'" v-on:country-changed="
                                                countryChanged
                                              " style="
                                                direction: ltr !important;
                                                text-align: left !important;
                                              " required maxlength="14" min="4">
                                            </vue-tel-input>
                                          </div>
                                        </div>
                                        <div class="col-xl-12">
                                          <div class="input-area mb-30">
                                            <input type="text" class="form-control" v-model="row.email"
                                              :placeholder="$t('contact.email')" />
                                          </div>
                                        </div>
                                        <div class="col-xl-12">
                                          <div class="input-area mb-30">
                                            <input type="text" class="form-control" v-model="row.notes"
                                              :placeholder="$t('contact.notes')" />
                                          </div>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                                <div class="tab-pane fade" id="profile-m" role="tabpanel"
                                  aria-labelledby="profile-tab-m">
                                  <p>{{ $t("cart.good_man_detail") }}</p>
                                  <div class="col-xl-12">
                                    <div class="input-area mb-30">
                                      <vue-tel-input class="form-control" v-model="row.mobile"
                                        :placeholder="$t('contact.mobile')" :defaultCountry="'KW'"
                                        v-on:country-changed="countryChanged" style="
                                          direction: ltr !important;
                                          text-align: left !important;
                                        ">
                                      </vue-tel-input>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="payment-inner mt-4">
                                <button class="theme_btn theme_btn_bg w-100" @click="submit()">
                                  {{ $t("cart.go_to_payment") }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="single-case-btns-section mt-10">
                          <button class="theme_btn theme_btn_bg w-100 case-whatsapp" @click="msgWhatsapp(row.title)">
                            {{ $t("app.contact") }}
                            <i class="fab fa-whatsapp"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="cases-feature mb-20 project-description">
                <h3 class="project-section-title">{{ $t("project.detail") }}</h3>
                <div class="project-description-body" v-html="row.body"></div>
                <br />

                <h4 class="mb-4 mt-4">{{ $t("app.share") }}</h4>
                <div class="row">
                  <div class="teams__thumb--social" style="display: contents">
                    <a :href="'https://facebook.com/sharer/sharer.php?u=' +
                      current_url
                      " target="_blank">
                      <i class="fab fa-facebook-f"></i>
                      <i class="fab fa-facebook-f"></i>
                    </a>
                    <a :href="'https://twitter.com/share?url=' + current_url" target="_blank">
                      <i class="fab fa-twitter"></i>
                      <i class="fab fa-twitter"></i>
                    </a>
                    <!-- <a
                  :href="
                    'https://pinterest.com/pin/create/bookmarklet/?&amp;url=' +
                    current_url
                  "
                  target="_blank"
                >
                  <i class="fab fa-pinterest"></i>
                  <i class="fab fa-pinterest"></i>
                </a> -->
                    <a :href="'https://www.linkedin.com/shareArticle?url=' +
                      current_url
                      " target="_blank">
                      <i class="fab fa-linkedin"></i>
                      <i class="fab fa-linkedin"></i>
                    </a>
                    <!-- <a href="javascript:;" @click="addToShares(row.id)">
                      <i class="far fa-share"></i>
                      <i class="far fa-share"></i>
                    </a> -->
                  </div>
                  <!-- <div class="article-tags">
                  <span>
                      <i class="far fa-share"></i>
                  </span>
                  <a href="javascript:;" @click.prevent="copyUrl()">
                      {{ $t('project.share') }}
                  </a>
              </div> -->
                </div>
                <!-- <h3 class="cases-title mb-20">لماذا تتبرع لهذا المشروع ؟</h3>
                    <p class="mb-30">
                      هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم
                      توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا
                      النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف
                      التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات.
                    </p>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="cases-single fix mb-30">
                          <div class="cases-single__icon">
                            <i class="far fa-check"></i>
                          </div>
                          <div class="cases-single__content fix ml-25">
                            <h5>نحن جديرون بالثقة</h5>
                            <p>
                              هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة،
                              لقد تم توليد هذا النص من مولد النص العربى
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="cases-single fix mb-30">
                          <div class="cases-single__icon">
                            <i class="far fa-check"></i>
                          </div>
                          <div class="cases-single__content fix ml-25">
                            <h5>نحن جديرون بالثقة</h5>
                            <p>
                              هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة،
                              لقد تم توليد هذا النص من مولد النص العربى
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="cases-single fix mb-30">
                          <div class="cases-single__icon">
                            <i class="far fa-check"></i>
                          </div>
                          <div class="cases-single__content fix ml-25">
                            <h5>نحن جديرون بالثقة</h5>
                            <p>
                              هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة،
                              لقد تم توليد هذا النص من مولد النص العربى
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="cases-single fix mb-30">
                          <div class="cases-single__icon">
                            <i class="far fa-check"></i>
                          </div>
                          <div class="cases-single__content fix ml-25">
                            <h5>نحن جديرون بالثقة</h5>
                            <p>
                              هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة،
                              لقد تم توليد هذا النص من مولد النص العربى
                            </p>
                          </div>
                        </div>
                      </div>
                    </div> -->
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-12 d-none d-lg-block project-donation-column">
            <div class="details-right-area">
              <div class="widget grey-bg2 mb-30">
                <div class="widget-post cases-information" id="donate">
                  <!-- <h3 class="cases-title">{{ $t("app.donation_values") }}</h3> -->
                  <div class="doante-select-area mt-0 wow fadeInUp2 animated" data-wow-delay=".1s">
                    <!-- Donation -->
                    <div class="self-donation">
                      <div>
                        <div class="form-group">
                          <div class="text-center">
                            <!-- <h4 style="color: black ; line-height: 1.8;">
                          هل ترغب في إضافة مشروع أخر أم الإنتقال إلي السلة
                          للتبرع ؟
                        </h4> -->
                            <div class="donation-form-left">
                              <div class="doante-select-area wow fadeInUp2 animated" data-wow-delay=".1s"
                                style="padding: 20px; padding-top: 0">
                                <h3 class="cases-title mb-30">
                                  {{ $t("app.donation_values") }}
                                </h3>
                                <div class="input-donate">
                                  <!-- donation options -->
                                  <button class="cont_btn" :style="$i18n.locale == 'ar'
                                      ? 'font-size:16px'
                                      : 'font-size:13px'
                                    " v-for="(row, index) in values" :key="index" @click="changeAmount(index, row)"
                                    :class="amount == row && !custom_amount.length
                                        ? 'active'
                                        : ''
                                      ">
                                    {{ row }}

                                    <span class="usd" v-if="locale == 'ar'">
                                      {{ currency == "KWD" ? "د.ك" : "ريال" }}
                                    </span>
                                    <span class="usd" v-else>
                                      {{ currency == "SAR" ? "SAR" : "KWD" }}
                                    </span>
                                  </button>
                                </div>

                                <h6 v-if="row.allow_donate_other_amount" class="text-center my-4">
                                  {{ $t("app.enter_Amount") }}
                                </h6>

                                <div v-if="row.allow_donate_other_amount" class="donate-cart pos-rel">
                                  <form class="donate-btn pos-rel">
                                    <input type="number" min="1" class="input-donat" v-model="custom_amount"
                                      :placeholder="$t('app.enter_amount')" />
                                  </form>

                                  <div class="plus-minus">
                                    <div :style="[
                                      locale == 'ar'
                                        ? { right: '0px' }
                                        : { left: '0px' },
                                    ]" class="cart inc">
                                      <i style="padding: 25px" :class="[
                                        locale == 'ar'
                                          ? 'far fa-chevron-right'
                                          : 'far fa-chevron-left',
                                      ]" @click="incrementCustomAmount()"></i>
                                    </div>
                                    <div :style="[
                                      locale == 'ar'
                                        ? { left: '0px' }
                                        : { right: '0px' },
                                    ]" class="cart dec">
                                      <i style="padding: 25px" :class="[
                                        locale == 'ar'
                                          ? 'far fa-chevron-left'
                                          : 'far fa-chevron-right',
                                      ]" @click="decrementCustomAmount()"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="donar-information donation-form white-bg mb-10 wow fadeInUp2 animated"
                                data-wow-delay=".1s">
                                <div class="section-title text-left mb-50">
                                  <h2 :style="$i18n.locale == 'en'
                                      ? 'text-align:left !important'
                                      : ''
                                    ">
                                    {{ $t("cart.payment_method") }}
                                  </h2>
                                </div>

                                <!-- payment methods -->
                                <div class="cc-selector row">
                                  <div class="col-4 col-md-3" v-for="method in paymentMethods"
                                    :key="method.PaymentMethodId" style="display: inline-block; margin: 5px">
                                    <input :id="'payment_' + method.PaymentMethodId" type="radio"
                                      :value="method.PaymentMethodId" :checked="payment_method == method.PaymentMethodId
                                          ? true
                                          : false
                                        " @change="
                                        pamyentMethod(method.PaymentMethodId)
                                        " name="payment_method" />
                                    <label class="payment-item" :for="'payment_' + method.PaymentMethodId">
                                      <img :src="method.ImageUrl" width="50px" loading="lazy"
                                        :alt="method.PaymentMethodEn" />
                                      <span class="payment-method-name">
                                        {{
                                          $i18n.locale == "ar"
                                            ? method.PaymentMethodAr
                                            : method.PaymentMethodEn
                                        }}
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div class="donar-information donation-form white-bg wow fadeInUp2 animated"
                                data-wow-delay=".1s">
                                <div class="section-title text-left mb-50">
                                  <h2 :style="$i18n.locale == 'en'
                                      ? 'text-align:left !important'
                                      : ''
                                    ">
                                    {{ $t("cart.donation_info") }}
                                  </h2>
                                </div>
                                <ul class="nav nav-tabs mb-15" id="myTab" role="tablist">
                                  <li class="nav-item">
                                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab"
                                      aria-controls="home" aria-selected="true">{{ $t("cart.donation_info") }}</a>
                                  </li>
                                  <li class="nav-item">
                                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab"
                                      aria-controls="profile" aria-selected="false">{{ $t("cart.good_man") }}</a>
                                  </li>
                                </ul>
                                <div class="tab-content" id="myTabContent">
                                  <div class="tab-pane fade show active" id="home" role="tabpanel"
                                    aria-labelledby="home-tab">
                                    <div class="row payment-inner">
                                      <form action="#">
                                        <div class="row">
                                          <div class="col-xl-12">
                                            <div class="input-area mb-30">
                                              <input type="text" class="form-control" v-model="row.name" :placeholder="$t('contact.name')
                                                " />
                                            </div>
                                          </div>
                                          <div class="col-xl-12">
                                            <!-- <div class="input-area mb-30">
                              <input
                                type="text"
                                class="form-control"
                                v-model="row.mobile"
                                :placeholder="$t('contact.mobile')"
                                required
                              />
                            </div> -->
                                            <div class="input-area mb-30">
                                              <vue-tel-input class="form-control" v-model="row.mobile" :placeholder="$t('contact.mobile')
                                                " :defaultCountry="'KW'" v-on:country-changed="
                                                  countryChanged
                                                " style="
                                                  direction: ltr !important;
                                                  text-align: left !important;
                                                " required maxlength="14" min="4">
                                              </vue-tel-input>
                                            </div>
                                          </div>
                                          <div class="col-xl-12">
                                            <div class="input-area mb-30">
                                              <input type="text" class="form-control" v-model="row.email" :placeholder="$t('contact.email')
                                                " />
                                            </div>
                                          </div>
                                          <div class="col-xl-12">
                                            <div class="input-area mb-30">
                                              <input type="text" class="form-control" v-model="row.notes" :placeholder="$t('contact.notes')
                                                " />
                                            </div>
                                          </div>
                                          <!-- <div class="col-xl-6"> -->
                                          <!-- <div class="input-area mb-30">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="البلد"
                                />
                              </div> -->
                                          <!-- </div> -->
                                          <div class="col">
                                            <div class="input-area mb-30">
                                              <input id="invoice" type="checkbox" />
                                              <label class="mx-1" for="invoice">
                                                {{ $t("cart.want_email") }}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                  <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <p>
                                      {{ $t("cart.good_man_detail") }}
                                    </p>
                                    <div class="col-xl-12">
                                      <!-- <div class="input-area mb-30">
                    <input
                      type="phone"
                      class="form-control"
                      v-model="row.mobile"
                      :placeholder="$t('contact.mobile')"
                      required
                      max="14"
                      min="4"
                    />
                  </div> -->
                                      <div class="input-area mb-30">
                                        <vue-tel-input class="form-control" v-model="row.mobile"
                                          :placeholder="$t('contact.mobile')" :defaultCountry="'KW'"
                                          v-on:country-changed="countryChanged" style="
                                            direction: ltr !important;
                                            text-align: left !important;
                                          ">
                                        </vue-tel-input>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="payment-inner mt-4">
                                  <button class="theme_btn theme_btn_bg" @click="submit()">
                                    {{ $t("cart.pay_now") }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Donation -->

                    <div class="single-case-btns-section">
                      <!-- donate button in project details -->
                      <!-- <button class="theme_btn theme_btn_bg w-100" :style="$i18n.locale == 'en' ? 'padding:17px' : ''"
                        @click="openPopup()">
                        {{ $t("app.donate_Now") }}
                      </button> -->
                      <!-- <button
                        class="theme_btn theme_btn_bg"
                        @click="navigateToCart"
                      >
                        <i class="far fa-shopping-cart"></i>
                      </button> -->
                      <button class="theme_btn theme_btn_bg w-100 mt-10 case-whatsapp" @click="msgWhatsapp(row.title)">
                        {{ $t("app.contact") }}
                        <i class="fab fa-whatsapp"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- <div class="widget-post">
                      <h3 class="cases-title mb-30">مشاريع متعلقة</h3>
                      <div class="post d-flex align-items-center mb-20">
                        <div class="post__thumb mr-20">
                          <img src="assets/img/cases/20.jpg" alt="" />
                        </div>
                        <div class="post__content">
                          <h5>
                            <a href="#">{{$t('app.project')}} خريجات ثانويه جمانة بنت ابي طالب</a>
                          </h5>
                          <a class="view_btn" href="#">تفاصيل المشروع</a>
                        </div>
                      </div>
                      <div class="post d-flex align-items-center mb-20">
                        <div class="post__thumb mr-20">
                          <img src="assets/img/cases/21.jpg" alt="" />
                        </div>
                        <div class="post__content">
                          <h5><a href="#">الآبار الجوفية في السودان</a></h5>
                          <a class="view_btn" href="#">تفاصيل المشروع</a>
                        </div>
                      </div>
                      <div class="post d-flex align-items-center mb-20">
                        <div class="post__thumb mr-20">
                          <img src="assets/img/cases/22.jpg" alt="" />
                        </div>
                        <div class="post__content">
                          <h5><a href="#">كسوة الشتاء</a></h5>
                          <a class="view_btn" href="#">تفاصيل المشروع</a>
                        </div>
                      </div>
                      <div class="post d-flex align-items-center mb-20">
                        <div class="post__thumb mr-20">
                          <img src="assets/img/cases/23.jpg" alt="" />
                        </div>
                        <div class="post__content">
                          <h5><a href="#">عمليات العيون في اليمن</a></h5>
                          <a class="view_btn" href="#">تفاصيل المشروع</a>
                        </div>
                      </div>
                      <div class="post d-flex align-items-center mb-20">
                        <div class="post__thumb mr-20">
                          <img src="assets/img/cases/24.jpg" alt="" />
                        </div>
                        <div class="post__content">
                          <h5>
                            <a href="#">توفير مقاعد متحركة لذوي الاحتياجات</a>
                          </h5>
                          <a class="view_btn" href="#">تفاصيل المشروع</a>
                        </div>
                      </div>
                    </div> -->
              </div>
            </div>
          </div>
        </div>

        <!-- Cart Model -->
        <div class="modal fade cart-popup" :class="locale == 'ar' ? 'rtl' : 'ltr'" id="cart-popup" style="display: none"
          tabindex="-1" role="dialog" aria-labelledby="cart-popup" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  <p><br /></p>
                </h5>
                <a @click="closePopup()" aria-label="current page" class="close">
                  <span aria-hidden="true">&times;</span>
                </a>
              </div>
              <div class="modal-body cart-popup">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group">
                      <div class="text-center">
                        <!-- <h4 style="color: black ; line-height: 1.8;">
                          هل ترغب في إضافة مشروع أخر أم الإنتقال إلي السلة
                          للتبرع ؟
                        </h4> -->
                        <div class="donation-form-left">
                          <div class="doante-select-area wow fadeInUp2 animated" data-wow-delay=".1s"
                            style="padding: 20px; padding-top: 0">
                            <h3 class="cases-title mb-30">
                              {{ $t("app.donation_values") }}
                            </h3>
                            <div class="input-donate">
                              <!-- donation options -->
                              <button class="cont_btn" :style="$i18n.locale == 'ar'
                                  ? 'font-size:16px'
                                  : 'font-size:13px'
                                " v-for="(row, index) in values" :key="index" @click="changeAmount(index, row)" :class="amount == row && !custom_amount.length
                                    ? 'active'
                                    : ''
                                  ">
                                {{ row }}

                                <span class="usd" v-if="locale == 'ar'">
                                  {{ currency == "KWD" ? "د.ك" : "ريال" }}
                                </span>
                                <span class="usd" v-else>
                                  {{ currency == "SAR" ? "SAR" : "KWD" }}
                                </span>
                              </button>
                            </div>

                            <h6 v-if="row.allow_donate_other_amount" class="text-center my-4">
                              {{ $t("app.enter_Amount") }}
                            </h6>

                            <div v-if="row.allow_donate_other_amount" class="donate-cart pos-rel">
                              <form class="donate-btn pos-rel">
                                <input type="number" min="1" class="input-donat" v-model="custom_amount"
                                  :placeholder="$t('app.enter_amount')" />
                              </form>

                              <div class="plus-minus">
                                <div :style="[
                                  locale == 'ar'
                                    ? { right: '0px' }
                                    : { left: '0px' },
                                ]" class="cart inc">
                                  <i style="padding: 25px" :class="[
                                    locale == 'ar'
                                      ? 'far fa-chevron-right'
                                      : 'far fa-chevron-left',
                                  ]" @click="incrementCustomAmount()"></i>
                                </div>
                                <div :style="[
                                  locale == 'ar'
                                    ? { left: '0px' }
                                    : { right: '0px' },
                                ]" class="cart dec">
                                  <i style="padding: 25px" :class="[
                                    locale == 'ar'
                                      ? 'far fa-chevron-left'
                                      : 'far fa-chevron-right',
                                  ]" @click="decrementCustomAmount()"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="donar-information donation-form white-bg mb-10 wow fadeInUp2 animated"
                            data-wow-delay=".1s">
                            <div class="section-title text-left mb-50">
                              <h2 :style="$i18n.locale == 'en'
                                  ? 'text-align:left !important'
                                  : ''
                                ">
                                {{ $t("cart.payment_method") }}
                              </h2>
                            </div>

                            <!-- payment methods -->
                            <div class="cc-selector row">
                              <div class="col-4 col-md-3" v-for="method in paymentMethods" :key="method.PaymentMethodId"
                                style="display: inline-block; margin: 5px">
                                <input :id="'payment_d_' + method.PaymentMethodId" type="radio"
                                  :value="method.PaymentMethodId" :checked="payment_method == method.PaymentMethodId
                                      ? true
                                      : false
                                    " @change="
                                    pamyentMethod(method.PaymentMethodId)
                                    " name="payment_method_d" />
                                <label class="payment-item" :for="'payment_d_' + method.PaymentMethodId">
                                  <img :src="method.ImageUrl" width="50px" loading="lazy"
                                    :alt="method.PaymentMethodEn" />
                                  <span class="payment-method-name">
                                    {{
                                      $i18n.locale == "ar"
                                        ? method.PaymentMethodAr
                                        : method.PaymentMethodEn
                                    }}
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>

                          <div class="donar-information donation-form white-bg wow fadeInUp2 animated"
                            data-wow-delay=".1s">
                            <div class="section-title text-left mb-50">
                              <h2 :style="$i18n.locale == 'en'
                                  ? 'text-align:left !important'
                                  : ''
                                ">
                                {{ $t("cart.donation_info") }}
                              </h2>
                            </div>
                            <ul class="nav nav-tabs mb-15" id="myTab" role="tablist">
                              <li class="nav-item">
                                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab"
                                  aria-controls="home" aria-selected="true">{{ $t("cart.donation_info") }}</a>
                              </li>
                              <li class="nav-item">
                                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab"
                                  aria-controls="profile" aria-selected="false">{{ $t("cart.good_man") }}</a>
                              </li>
                            </ul>
                            <div class="tab-content" id="myTabContent">
                              <div class="tab-pane fade show active" id="home" role="tabpanel"
                                aria-labelledby="home-tab">
                                <div class="row payment-inner">
                                  <form action="#">
                                    <div class="row">
                                      <div class="col-xl-12">
                                        <div class="input-area mb-30">
                                          <input type="text" class="form-control" v-model="row.name"
                                            :placeholder="$t('contact.name')" />
                                        </div>
                                      </div>
                                      <div class="col-xl-12">
                                        <!-- <div class="input-area mb-30">
                              <input
                                type="text"
                                class="form-control"
                                v-model="row.mobile"
                                :placeholder="$t('contact.mobile')"
                                required
                              />
                            </div> -->
                                        <div class="input-area mb-30">
                                          <vue-tel-input class="form-control" v-model="row.mobile"
                                            :placeholder="$t('contact.mobile')" :defaultCountry="'KW'"
                                            v-on:country-changed="
                                              countryChanged
                                            " style="
                                              direction: ltr !important;
                                              text-align: left !important;
                                            " required maxlength="14" min="4">
                                          </vue-tel-input>
                                        </div>
                                      </div>
                                      <div class="col-xl-12">
                                        <div class="input-area mb-30">
                                          <input type="text" class="form-control" v-model="row.email"
                                            :placeholder="$t('contact.email')" />
                                        </div>
                                      </div>
                                      <div class="col-xl-12">
                                        <div class="input-area mb-30">
                                          <input type="text" class="form-control" v-model="row.notes"
                                            :placeholder="$t('contact.notes')" />
                                        </div>
                                      </div>
                                      <!-- <div class="col-xl-6"> -->
                                      <!-- <div class="input-area mb-30">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="البلد"
                                />
                              </div> -->
                                      <!-- </div> -->
                                      <div class="col">
                                        <div class="input-area mb-30">
                                          <input id="invoice" type="checkbox" />
                                          <label class="mx-1" for="invoice">
                                            {{ $t("cart.want_email") }}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                              <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                <p>
                                  {{ $t("cart.good_man_detail") }}
                                </p>
                                <div class="col-xl-12">
                                  <!-- <div class="input-area mb-30">
                    <input
                      type="phone"
                      class="form-control"
                      v-model="row.mobile"
                      :placeholder="$t('contact.mobile')"
                      required
                      max="14"
                      min="4"
                    />
                  </div> -->
                                  <div class="input-area mb-30">
                                    <vue-tel-input class="form-control" v-model="row.mobile"
                                      :placeholder="$t('contact.mobile')" :defaultCountry="'KW'"
                                      v-on:country-changed="countryChanged" style="
                                        direction: ltr !important;
                                        text-align: left !important;
                                      ">
                                    </vue-tel-input>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="payment-inner mt-4">
                              <button class="theme_btn theme_btn_bg" @click="submit()">
                                {{ $t("cart.go_to_payment") }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="modal-footer">
                <div class="col-6 ">
                  <button
                    @click="navigateToCart()"
                    class="theme_btn theme_btn_bg text-center"
                    style="padding: 20px 30px !important; border: 0;"
                  >
                    الإنتقال للسلة للتبرع
                  </button>
                </div>
                <div class="col-6 ">
                  <a
                    href="/"
                    class="theme_btn theme_btn_bg case-whatsapp"
                    style="padding: 20px 30px !important; border: 0;"
                    >إضافة مشروع أخر
                  </a>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import sendEvent, { resolveDonorData } from "@/helpers/sendEvent";
import { trackAddToCart, trackCheckout } from "@/helpers/pixel";
import carousel from "vue-owl-carousel2";
import iziToast from "izitoast";
import { VueTelInput } from "vue-tel-input";
import { getPaymentMethods } from "@/data/paymentMethods";
export default {
  name: "project-show",
  components: {
    carousel,
    Banner: () => import("@/components/Banner.vue"),
    VueTelInput,
  },
  data() {
    return {
      //
      item: {
        image: {
          url: "/assets/img/bg/12.jpg",
        },
        en: {
          title: "Orphans",
        },
        ar: {
          title: "المشاريع",
        },
      },
      items: [],
      refs: "pages",

      //
      auth: {
        access_token: "",
      },
      locale: "ar",
      pgLoading: false,
      itemsLoading: false,

      row: "",
      row: {
        is_anonymous: 0,
        name: "",
        mobile: "",
        send_email: 0,
        email_address: "",
        is_paid: 0,
        payment_method: 1,
        notes: "",
        ccode: "",
      },

      magnific_popup: false,
      video_url: "",
      tab_item: 1,
      galleries: [],

      sadkaaOrZakaa: 0,

      amount_id: 1,
      amount: "",
      custom_amount: "",

      share: "",
      type: "",

      current_url: window.location.origin + this.$route.path,

      whatsNumber: window.whatsNumber,

      video: "https://www.youtube.com/watch?v=3H-PmCiL0bE",

      info: "",

      payment_method: 1,

      type_id: 0,

      types: [],
      values: [],

      btnLoading: false,
      currency: "KWD",

      paymentStatus: 1,
      paymentMethods: [],
    };
  },
  mounted() {
  },
  // head: {
  //     title: {
  //         inner: 'It will be a pleasure'
  //     },
  // },

  // metaInfo() {
  //   return {
  //     title: this.row.title,
  //     meta: [
  //       {
  //         name: "description",
  //         content: this.row.title,
  //       },
  //       {
  //         name: "keywords",
  //         content: this.row.title,
  //       },
  //       {
  //         name: "title",
  //         content: this.row.title,
  //       },
  //       {
  //         hid: `og-title`,
  //         property: "og:title",
  //         content: this.row.title,
  //       },
  //       {
  //         hid: `og-description`,
  //         property: "og:description",
  //         content: this.row.title,
  //       },
  //       {
  //         hid: `og-image`,
  //         property: "og:image",
  //         content: this.row.image ? this.row.image.url : "",
  //       },
  //       {
  //         hid: `og-url`,
  //         property: "og:url",
  //         content: "https://hrskw.org.kw/projects/" + this.row.slug,
  //       },
  //     ],
  //   };
  // },
  watch: {
    "$route.params.slug"() {
      this.fetchData();
    },
  },
  created() {
    //

    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    if (this.$route.query.share) {
      this.share = this.$route.query.share;
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }

    this.fetchData();
    this.fetchPayment();
    this.fetchPaymentMethods();
  },
  methods: {
    getTitleSeo() {
      let lang = this.$i18n.locale;
      let meta = this.row.meta;

      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_title
          : meta.en.meta_title
        : "projects";
      return data;
    },

    getDescSeo() {
      let lang = this.$i18n.locale;
      let meta = this.row.meta;
      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_description
          : meta.en.meta_description
        : "meta_description";
      return data;
    },
    getKeywordsSeo() {
      let lang = this.$i18n.locale;
      let meta = this.row.meta;
      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_keywords
          : meta.en.meta_keywords
        : "meta_keywords";
      return data;
    },

    async fetchPaymentMethods() {
      this.paymentMethods = await getPaymentMethods();
    },

    fetchPayment() {
      const options = {
        url: window.baseURL + "/settings/26",
        method: "GET",
      };

      this.$axios(options)
        .then((res) => {
          this.paymentStatus = res.data.status;
        })
        .catch(() => {
          this.paymentStatus = 0;
        })
        .finally(() => { });
    },
    msgWhatsapp(msg) {
      window.open(window.whatsAppNo + msg, "_blank");
    },

    async navigateToHome() {
      await this.$router.push({ name: "home" });
    },
    async navigateToCart() {
      await this.$router.push({ name: "carts" });
      window.location.reload();
    },

    sliderBgImage() {
      return this.row.image
        ? `url( ${this.row.image.url} )`
        : `url(/assets/img/logo/logo.svg)`;
    },
    sliderGalleries(index) {
      //console.log('test',this.galleries );
      return this.galleries[index]
        ? `url( ${this.galleries[index].image_url} )`
        : `url(/assets/img/logo/logo.svg)`;
    },
    //
    fetchData() {
      window.scrollTo(0, 0);
      this.values = [];
      this.itemsLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/projects/" + this.$route.params.slug,
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          share: this.share,
          type: this.type,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.itemsLoading = false;
          this.row = res.data.row;

          this.amount = res.data.row.donation_option1;
          this.galleries = res.data.row.galleries;
          this.video = this.row.videos[0]
            ? this.row.videos[0].video_url
            : this.video;

          //this.fetchDonationsValues();
          if (res.data.row.donation_option1) {
            this.values.push(res.data.row.donation_option1);
          }
          if (res.data.row.donation_option2) {
            this.values.push(res.data.row.donation_option2);
          }
          if (res.data.row.donation_option3) {
            this.values.push(res.data.row.donation_option3);
          }
          if (res.data.row.donation_option4) {
            this.values.push(res.data.row.donation_option4);
          }
          if (res.data.row.donation_option5) {
            this.values.push(res.data.row.donation_option5);
          }

          this.loadSliderJS();
          //this.updateMeta();
        })
        .catch(() => {
          this.itemsLoading = false;
          this.$router.push({
            name: "404",
          });
        })
        .finally(() => {
          this.itemsLoading = false;
        });
    },

    updateMeta() {
      document.title = this.row.title;
      document.head.querySelector("meta[name=title]").content = this.row.title;
      document.head.querySelector("meta[name=description]").content =
        this.row.title;
      document.head.querySelector("meta[name=keywords]").content =
        this.row.title;
      document.head.querySelector("meta[name=ogtitle]").content =
        this.row.title;
      document.head.querySelector("meta[name=ogdescription]").content =
        this.row.title;
    },

    // fetchDonationsValues() {
    //   this.pgLoading = true;
    //   this.axios.defaults.headers.common = {
    //     "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
    //   };
    //   const options = {
    //     url: window.baseURL + "/donations/values",
    //     method: "GET",
    //     data: {},
    //     params: {
    //       locale: this.locale,
    //     },
    //   };
    //   this.$axios(options)
    //     .then((res) => {
    //       //this.pgLoading = false;
    //       this.values = res.data.rows;
    //       this.amount_id = res.data.rows[0].id;
    //       this.amount = res.data.rows[0].amount;

    //       this.fetchDonationsTypes();
    //     })
    //     .catch(() => {})
    //     .finally(() => {});
    // },

    fetchDonationsTypes() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/donations/types",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          currency: this.currency,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.types = res.data.rows;
          this.type_id = res.data.rows[0].id;
        })
        .catch(() => { })
        .finally(() => { });
    },

    pamyentMethod(id) {
      this.payment_method = id;
    },

    submit() {
      // condition mobile required in regular donor
      // document.getElementById("home-tab").classList.contains("active")
      // if (this.row.mobile == "") {
      //   this.btnLoading = false;

      //   return iziToast.warning({
      //     icon: "ti-alert",
      //     title: "",
      //     message: this.$t("app.error_phone_required"),
      //   });
      // }
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      let amount_total = this.amount;
      if (Number(this.custom_amount) >= 1) {
        amount_total = this.custom_amount;
      } else {
        // amount_total = 1;
      }
      const donorEmail = (this.row.email || this.row.email_address || "").trim();
      const donorName = (this.row.name || "").trim();
      const donorMobile = (this.row.mobile || "").trim();
      const donorCcode = (this.row.ccode || "+965").trim();

      if (donorMobile) {
        localStorage.setItem("donor_mobile", donorMobile);
      }
      if (donorCcode) {
        localStorage.setItem("donor_ccode", donorCcode);
      }
      if (donorEmail && donorEmail.includes("@")) {
        localStorage.setItem("donor_email", donorEmail);
      }
      if (donorName) {
        localStorage.setItem("donor_name", donorName);
      }

      const donorInfo = {
        mobile: donorMobile,
        ccode: donorCcode,
        email: donorEmail,
        name: donorName,
      };

      const donorData = resolveDonorData(donorInfo);
      // trackCheckout fires browser pixel + CAPI for InitiateCheckout & AddPaymentInfo.
      const checkoutData = trackCheckout(
        {
          value: amount_total,
          currency: "KWD",
          content_ids: [this.row.id],
          content_name: this.row.title,
          content_type: "projects",
          num_items: 1,
          payment_method: this.payment_method,
        },
        { ...donorData }
      );
      const initEventId =
        (checkoutData && (checkoutData._eventId || checkoutData.event_id)) ||
        donorData.external_id ||
        null;

      const options = {
        url: window.baseURL + "/donations",
        method: "POST",
        data: {
          is_anonymous: this.row.is_anonymous,
          name: donorData.name,
          first_name: donorData.first_name,
          last_name: donorData.last_name,
          mobile: donorData.mobile,
          ccode: donorData.ccode,
          send_email: this.row.send_email,
          email_address: donorData.email,
          email: donorData.email,
          is_paid: this.row.is_paid,
          payment_method: this.payment_method,
          total: amount_total,
          itemName: this.row.itemName,
          currency: "KWD",
          notes: this.row.notes,

          model_id: this.row.id,
          model_type: "projects",
          type_id: this.type_id,
          share: this.share,
          type: this.type,

          event_id: initEventId,
          fbc: donorData.fbc,
          fbp: donorData.fbp,
          external_id: donorData.external_id,
        },
      };

      this.$axios(options)
        .then((res) => {
          this.btnLoading = false;
          // go to payment
          if (res.data.link) {
            setTimeout(() => {
              window.open(res.data.link, "_self");
            }, 250);
            // this.href = res.data.link;
            // this.openPopup();
            // var w = window.open();
            // if( w ) {
            //   w.close();
            //   console.log('working...');
            // } else {
            //   console.log('not working...');
            // }
            //w
          } else {
            iziToast.warning({
              icon: "ti-alert",
              title: "",
              message: res.response
                ? this.$t("app.error_contact_us")
                : "" + res,
            });
          }
          // iziToast.success({
          //   icon: 'ti-check',
          //   title: '',
          //   message: 'Donation Submit Successfully',
          // });
          //this.fetchCarts();
        })
        .catch((err) => {
          this.btnLoading = false;

          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: err.response ? this.$t("app.error_contact_us") : "" + err,
          });
        });
    },
    countryChanged(country) {
      this.row.ccode = country.dialCode;
    },

    changeCheck1() {
      if (this.row.is_anonymous == 1) {
        this.row.is_anonymous = 0;
      } else {
        this.row.is_anonymous = 1;
      }
    },

    changeCheck2() {
      if (this.row.send_email == 1) {
        this.row.send_email = 0;
      } else {
        this.row.send_email = 1;
      }
    },

    openVideo: function (path) {
      this.magnific_popup = true;
      this.video_url = path;
    },

    closeMagnific: function () {
      this.magnific_popup = false;
      this.video_url = "";
    },

    openTab: function (id) {
      this.tab_item = id;
    },

    loadSliderJS() {
      let recaptchaScript1 = document.createElement("script");
      let recaptchaScript2 = document.createElement("script");

      recaptchaScript1.setAttribute(
        "src",
        "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.js",
      );
      recaptchaScript2.setAttribute(
        "src",
        "/assets/js/project-slider-script.js",
      );

      document.body.appendChild(recaptchaScript1);
      document.body.appendChild(recaptchaScript2);
    },

    incrementCustomAmount() {
      this.custom_amount = parseInt(this.custom_amount) + 1;
    },

    decrementCustomAmount() {
      if (this.custom_amount > 1) {
        this.custom_amount = parseInt(this.custom_amount) - 1;
      }
    },
    openPopup() {
      let app = document.querySelectorAll("#cart-popup");
      let appx = app[app.length - 1];
      appx.classList.add("show");
      appx.style.display = "block";

      let body = document.querySelectorAll("body");
      let bodyx = body[body.length - 1];
      bodyx.classList.add("modal-open");

      let div = document.createElement("div");
      div.classList.add("modal-backdrop", "fade", "show");
      bodyx.appendChild(div);
    },

    closePopup() {
      let app = document.querySelectorAll("#cart-popup");
      let appx = app[app.length - 1];
      appx.classList.remove("show");
      appx.style.display = "";

      let body = document.querySelectorAll("body");
      let bodyx = body[body.length - 1];
      bodyx.classList.remove("modal-open");

      // Remove all modal backdrops
      const backdrops = document.querySelectorAll("div.modal-backdrop");
      backdrops.forEach((backdrop) => {
        bodyx.removeChild(backdrop);
      });
    },

    addToCart() {
      // paymentStatus
      if (this.paymentStatus == 0) {
        iziToast.warning({
          icon: "ti-alert",
          title: "",
          message: this.$t("app.payment_status_error"),
        });
        return false;
      }
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      let amount_total = this.amount;
      if (Number(this.custom_amount) >= 1) {
        amount_total = this.custom_amount;
      } else {
        // amount_total = 1;
      }
      const options = {
        url: window.baseURL + "/carts",
        method: "POST",
        data: {
          model_id: this.row.id,
          model_type: "projects",
          type_id: this.type_id,
          amount: amount_total,
          share: this.share,
          type: this.type,
        },
        params: {},
      };
      this.$axios(options)
        .then(async () => {
          this.btnLoading = false;
          sendEvent("AddToCart", amount_total);
          trackAddToCart({
            value: amount_total,
            currency: "KWD",
            content_ids: [this.row.id],
            content_name: this.row.title,
            content_type: "projects",
          });
          iziToast.success({
            icon: "ti-check",
            title: "",
            message: this.$t("app.add_msg"),
          });
          this.openPopup();
          // this.$router.push({ name: "carts" });
          // window.location.reload()
        })
        .catch((err) => {
          this.btnLoading = false;
          if (err.response && err.response.status == 401) {
            this.removeLocalStorage();
            this.$router.push({ name: "login" });
          } else {
            iziToast.warning({
              icon: "ti-alert",
              title: "",
              message: err.response ? err.response.data.message : "" + err,
            });
            this.openPopup();
          }
        })
        .finally(() => { });
    },

    removeLocalStorage() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_image");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("user_id");
      localStorage.removeItem("email");
      localStorage.removeItem("id_number");
    },

    showLoading(proid) {
      let btn = document.querySelectorAll("a#btnDonate_" + proid);
      let app = btn[btn.length - 1];
      app.classList.add("hidden");

      let loading = document.querySelectorAll("a#btnLoading_" + proid);
      let app2 = loading[loading.length - 1];
      app2.classList.remove("hidden");
    },

    hideLoading(proid) {
      let btn = document.querySelectorAll("a#btnDonate_" + proid);
      let app = btn[btn.length - 1];
      app.classList.remove("hidden");

      let loading = document.querySelectorAll("a#btnLoading_" + proid);
      let app2 = loading[loading.length - 1];
      app2.classList.add("hidden");
    },

    successLoading(proid) {
      let btn = document.querySelectorAll("a#btnDonate_" + proid);
      let app = btn[btn.length - 1];
      app.classList.add("hidden");

      let loading = document.querySelectorAll("a#btnLoading_" + proid);
      let app2 = loading[loading.length - 1];
      app2.classList.add("hidden");

      let success = document.querySelectorAll("a#btnSuccess_" + proid);
      let app3 = success[success.length - 1];
      app3.classList.remove("hidden");
    },

    changeType: function (id) {
      this.type_id = id;
    },

    changeAmount: function (id, amount) {
      this.amount = amount;
      //this.amount_id = id;
      this.custom_amount = "";
    },

    changeTSOrZ: function (id) {
      this.sadkaaOrZakaa = id;
    },

    addToShares(proid) {
      this.$axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ${this.auth.access_token}`,
      };
      const options = {
        url: window.baseURL + "/shares",
        method: "POST",
        data: {
          decrypt_model_id: proid,
          model: "projects",
          user_id: true,
          status: true,
        },
        params: {},
      };
      console.log(`Bearer ` + this.auth.access_token);
      console.log(options);
      this.$axios(options)
        .then(() => {
          iziToast.success({
            icon: "ti-check",
            title: "",
            message: this.$t("app.share_msg"),
          });
        })
        .catch((err) => {
          if (err.response && err.response.status == 401) {
            console.log(err.response.message);
            this.removeLocalStorage();
            this.$router.push({ name: "login" });
          } else {
            iziToast.warning({
              icon: "ti-alert",
              title: "",
              message: this.$t("app.share_msg_failed"),
            });
          }
        })
        .finally(() => { });
    },

    // This can also prevent copy + paste invalid character
    // filterInput(e){
    //   e.target.value = e.target.value.replace(/[^0-9]+/g, '');
    // },

    copyUrl() {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = this.current_url;
      dummy.select();
      const msg = document.execCommand("copy");
      document.body.removeChild(dummy);
      if (msg) {
        iziToast.success({
          icon: "ti-check",
          title: "",
          message: "تم إنشاء رابط مشاركة بنجاح",
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
//
<style src="vue-tel-input/dist/vue-tel-input.css"></style>
;
<style scoped>
.btn-size {
  cursor: pointer;
  height: 50px;
}

.vue-tel-input {
  height: 50px;
}

.vue-tel-input .vti__dropdown {
  width: 70px !important;
}

.vue-tel-input .vti__dropdown-arrow {
  width: 50px !important;
  margin-top: -10px !important;
  position: static !important;
}

.vti__dropdown-list,
.vti__dropdown-list.below {
  z-index: 1000 !important;
}

.donation-form {
  padding: 20px !important;
}

.Home-slider-slide {
  aspect-ratio: 1.8 !important;
  width: 100%;
  height: auto;
}

@media (max-width: 767px) {
  .cases-wrapper-box .cases__content h2 {
    font-size: 17px;
  }

  .cases-details-area {
    padding-top: 0 !important;
  }
}
</style>

<style>
@media (max-width: 767px) {
  .page-header-bg {
    display: none !important;
  }
}
</style>

<style scoped>
.widget .widget-post {
  padding-inline: 20px !important;
}

.self-donation {
  .cases-title {
    font-size: 15px;
    margin-bottom: 15px;
    text-align: center;
  }

  .doante-select-area {
    width: 100% !important;
    padding-inline: 0 !important;
  }

  .section-title h2 {
    font-size: 16px !important;
  }

  .payment-item img {
    width: 55px !important;
    aspect-ratio: 1.9 !important;
  }

  .section-title {
    margin-bottom: 20px !important;
  }

  .nav-tabs .nav-item .nav-link::before {
    right: 8px !important;
    top: 14px !important;
  }

  .nav-tabs .nav-item .nav-link::after {
    width: 25px !important;
    height: 25px !important;
    right: 3px !important;
    top: 9px !important;
  }
}
</style>

<style scoped>
/* Keep the redesign confined to this page and its existing form wrappers. */
.project-details-page {
  color: #001234;
  background: #f7f9fb;
}

.project-details-page ::v-deep .project-details-hero .page-title-area {
  display: flex !important;
  align-items: center;
  min-height: 200px !important;
  padding: 32px 0;
  background-size: cover;
  background-position: center;
  position: relative;
}

.project-details-page ::v-deep .project-details-hero .page-title-area::before {
  background: linear-gradient(90deg, rgba(0, 18, 52, .42), rgba(0, 18, 52, .58));
  z-index: 0;
  opacity: 1;
}

.project-details-page ::v-deep .project-details-hero .page-title-wrapper {
  position: relative;
  padding: 0;
}

.project-details-page ::v-deep .project-details-hero .page-title {
  font-size: 28px;
  line-height: 1.5;
  margin-bottom: 12px;
}

.project-details-page ::v-deep .project-details-hero .breadcrumb-list {
  margin: 0;
}

.project-details-page ::v-deep .project-details-hero .breadcrumb-list li a,
.project-details-page ::v-deep .project-details-hero .breadcrumb-list li a i {
  font-size: 13px;
  font-weight: 400;
}

.project-details-page .cases-details-area {
  padding-block: 32px 48px !important;
}

.project-details-page .cases-details-area > .container {
  max-width: 1320px;
  padding-inline: 24px;
}

.project-details-page .project-details-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 28px;
  align-items: start;
  margin: 0;
}

.project-details-page .project-content-column,
.project-details-page .project-donation-column,
.project-details-page .project-donation-mobile {
  min-width: 0;
  max-width: none;
  width: 100%;
  padding: 0;
}

.project-details-page .details-left-area {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 0;
}

.project-details-page .cases-wrapper-box,
.project-details-page .project-description,
.project-details-page .details-right-area > .widget {
  background: #fff;
  border: 1px solid #e8edf2;
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(0, 18, 52, .045);
  margin: 0;
}

.project-details-page .cases-wrapper-box .cases__content {
  padding: 24px;
}

.project-details-page .project-media {
  margin: -24px -24px 24px;
  overflow: hidden;
  border-radius: 15px 15px 0 0;
  background: #f1f6fa;
}

.project-details-page .project-media .Home-slider-slide {
  aspect-ratio: 1.8 !important;
  width: 100%;
  height: auto !important;
  min-height: 0;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border: 0;
}

.project-details-page ::v-deep .project-media .moving-waves::before {
  display: none;
}

.project-details-page ::v-deep .project-media .owl-nav {
  bottom: 16px;
  inset-inline-end: 16px;
  margin: 0;
}

.project-details-page ::v-deep .project-media .owl-nav.disabled {
  display: none !important;
}

.project-details-page ::v-deep .project-media .owl-nav button {
  width: 36px;
  height: 36px;
  border-radius: 10px;
}

.project-details-page .cases-wrapper-box .single-case-details-title {
  font-size: 26px;
  line-height: 1.5;
  margin-bottom: 16px;
  overflow-wrap: anywhere;
}

.project-details-page .cases--author {
  margin-bottom: 20px;
}

.project-details-page .cases--author .semi-02-title {
  font-size: 14px;
  line-height: 1.6;
}

.project-details-page .cases--author span {
  font-size: 12px;
  color: #6e798b;
}

.project-details-page .cases--author ::v-deep .flag-icon {
  font-size: 28px !important;
}

.project-details-page .project-progress-track {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.project-details-page .cases-meta .cases-progress .progress {
  width: 100%;
  height: 7px;
  border-radius: 8px;
  background: #edf0f3;
  margin: 0;
}

.project-details-page .cases-meta .progress-bar {
  background: #f8327d;
  border-radius: inherit;
}

.project-details-page .project-progress-track h3 {
  color: #f8327d;
  font-size: 14px;
  line-height: 1;
  margin: 0;
}

.project-details-page .project-financial-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding-top: 16px;
  border-top: 1px solid #edf0f3;
  text-align: center;
}

.project-details-page .project-financial-summary > * {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding-inline: 8px;
  margin: 0 !important;
  color: #6e798b;
  font-size: 12px !important;
  font-weight: 400;
  line-height: 1.6;
}

.project-details-page .project-financial-summary > * + * {
  border-inline-start: 1px solid #edf0f3;
}

.project-details-page .project-financial-summary strong,
.project-details-page .project-financial-summary .funding span {
  color: #001234;
  font-size: 16px !important;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.project-details-page .project-description {
  padding: 24px;
}

.project-details-page .project-section-title {
  font-size: 20px;
  line-height: 1.5;
  margin-bottom: 16px;
}

.project-details-page .project-description-body,
.project-details-page .project-description-body ::v-deep p,
.project-details-page .project-description-body ::v-deep span {
  font-family: inherit !important;
  color: #536175;
  font-size: 15px !important;
  line-height: 1.8 !important;
}

.project-details-page .project-description-body ::v-deep p {
  margin-bottom: 12px !important;
}

.project-details-page .project-description-body ::v-deep img,
.project-details-page .project-description-body ::v-deep iframe,
.project-details-page .project-description-body ::v-deep table {
  max-width: 100%;
}

.project-details-page .project-description > br {
  display: none;
}

.project-details-page .project-description > h4 {
  font-size: 14px;
  border-top: 1px solid #edf0f3;
  padding-top: 16px;
  margin-block: 20px 12px !important;
}

.project-details-page .project-description > .row {
  margin: 0;
  gap: 8px;
}

.project-details-page .project-description .teams__thumb--social a {
  width: 36px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #e8edf2;
  border-radius: 50%;
  color: #1f94d1;
  background: #fff;
  margin: 0;
}

.project-details-page .project-description .teams__thumb--social a:hover {
  background: #fff4f8;
  color: #f8327d;
  border-color: #f8327d;
}

.project-details-page .project-description .teams__thumb--social a:hover i {
  color: #f8327d;
}

.project-details-page .details-right-area .widget-post {
  padding: 20px !important;
}

.project-details-page .details-right-area .doante-select-area {
  position: static;
  width: 100%;
  padding: 0 !important;
  margin: 0;
}

.project-details-page .details-right-area .form-group {
  margin-bottom: 0;
}

.project-details-page .details-right-area .cases-title,
.project-details-page .details-right-area .section-title h2 {
  font-size: 16px !important;
  line-height: 1.6;
  text-align: start;
  margin: 0 0 12px;
}

.project-details-page .details-right-area .section-title {
  margin-bottom: 12px !important;
}

.project-details-page .details-right-area .input-donate {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(62px, 1fr));
  gap: 8px;
}

.project-details-page .details-right-area .input-donate .cont_btn {
  min-width: 0;
  height: 44px;
  margin: 0;
  padding: 8px 4px;
  border: 1px solid #e3e9ef;
  border-radius: 10px;
  color: #001234;
  background: #fff;
  font-size: 14px !important;
}

.project-details-page .details-right-area .input-donate .cont_btn:hover {
  background: #f0f8fc;
  border-color: #1f94d1;
}

.project-details-page .details-right-area .input-donate .cont_btn.active {
  background: #1f94d1 !important;
  border-color: #1f94d1;
  color: #fff;
}

.project-details-page .details-right-area .doante-select-area > h6 {
  font-size: 12px;
  color: #6e798b;
  margin-block: 12px !important;
}

.project-details-page .details-right-area .donate-cart,
.project-details-page .details-right-area .donate-cart .donate-btn input {
  height: 46px;
}

.project-details-page .details-right-area .donate-cart .donate-btn input {
  border: 1px solid #e3e9ef;
  border-radius: 10px;
  padding-inline: 44px;
  font-size: 14px;
  background: #fff;
}

.project-details-page .details-right-area .donate-cart .cart i {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 44px;
  padding: 0 !important;
  font-size: 12px;
}

.project-details-page .details-right-area .donation-form {
  padding: 20px 0 0 !important;
  margin: 20px 0 0;
  border-top: 1px solid #edf0f3;
}

.project-details-page .details-right-area .cc-selector {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
  gap: 8px;
  margin: 0;
}

.project-details-page .details-right-area .cc-selector > div {
  position: relative;
  width: auto;
  max-width: none;
  min-width: 0;
  padding: 0;
  margin: 0 !important;
}

.project-details-page .details-right-area .cc-selector input {
  position: absolute;
  width: 1px;
  height: 1px;
}

.project-details-page .details-right-area .payment-item {
  height: 76px;
  min-width: 0;
  padding: 8px;
  margin: 0;
  border: 1px solid #e3e9ef;
  border-radius: 10px;
  background: #fff;
}

.project-details-page .details-right-area .payment-item:hover,
.project-details-page .details-right-area .cc-selector input:checked + .payment-item {
  border: 1px solid #f8327d;
  padding: 8px;
  background: #fff4f8;
}

.project-details-page .details-right-area .payment-item img {
  width: 56px !important;
  height: 30px;
  object-fit: contain;
}

.project-details-page .details-right-area .payment-method-name {
  max-width: none;
  font-size: 11px;
  line-height: 1.5;
  color: #536175;
}

.project-details-page .details-right-area .nav-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.project-details-page .details-right-area .nav-tabs .nav-item {
  min-width: 0;
  margin: 0;
}

.project-details-page .details-right-area .nav-tabs .nav-link {
  border: 1px solid #e3e9ef;
  border-radius: 10px;
  padding: 12px 4px;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
  background: #fff;
}

.project-details-page .details-right-area .nav-tabs .nav-link::before,
.project-details-page .details-right-area .nav-tabs .nav-link::after {
  display: none;
}

.project-details-page .details-right-area .nav-tabs .nav-link.active,
.project-details-page .details-right-area .nav-tabs .nav-link:hover {
  color: #1f94d1;
  background: #f0f8fc;
  border: 1px solid #1f94d1;
}

.project-details-page .details-right-area .payment-inner.row,
.project-details-page .details-right-area .payment-inner form > .row {
  margin: 0;
}

.project-details-page .details-right-area .payment-inner form,
.project-details-page .details-right-area .payment-inner form > .row > div {
  width: 100%;
  padding: 0;
}

.project-details-page .details-right-area .input-area {
  margin-bottom: 12px;
}

.project-details-page .details-right-area .input-area .form-control {
  width: 100%;
  height: 46px;
  border: 1px solid #e3e9ef;
  border-radius: 10px;
  padding: 10px 12px;
  color: #001234;
  font-size: 14px;
  background: #fff;
}

.project-details-page .details-right-area .input-area .form-control::placeholder {
  color: #6e798b;
}

.project-details-page .details-right-area .input-area .form-control:focus,
.project-details-page .details-right-area .vue-tel-input:focus-within {
  border-color: #1f94d1;
  box-shadow: 0 0 0 3px rgba(31, 148, 209, .1);
}

.project-details-page .details-right-area .input-area .vue-tel-input {
  padding: 0;
}

.project-details-page .details-right-area ::v-deep .vti__input {
  min-width: 0;
  border-radius: 0 10px 10px 0;
  color: #001234;
  font-size: 14px;
}

.project-details-page .details-right-area ::v-deep .vti__dropdown {
  border-radius: 10px 0 0 10px;
}

.project-details-page .details-right-area ::v-deep .vti__dropdown-list {
  width: 280px;
  max-width: calc(100vw - 72px);
  text-align: left;
}

.project-details-page .details-right-area .input-area label,
.project-details-page .details-right-area .tab-pane > p {
  font-size: 12px;
  line-height: 1.8;
  color: #536175;
  margin-bottom: 12px;
}

.project-details-page .details-right-area .payment-inner.mt-4 {
  margin-top: 16px !important;
}

.project-details-page .details-right-area .doante-select-area .theme_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 48px;
  padding: 12px 16px;
  border: 0;
  border-radius: 10px;
  background: #f8327d;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.5;
}

.project-details-page .details-right-area .doante-select-area .theme_btn::before {
  background: #e52570 !important;
  border-radius: inherit;
}

.project-details-page .details-right-area .single-case-btns-section {
  margin-top: 12px;
}

.project-details-page .details-right-area .doante-select-area .case-whatsapp {
  height: 44px;
  margin: 0;
  background: #fff !important;
  border: 1px solid #dcece5;
  color: #218556;
  font-size: 13px;
}

.project-details-page .details-right-area .case-whatsapp i {
  color: inherit !important;
}

.project-details-page .details-right-area .doante-select-area .case-whatsapp::before {
  background: #edf8f2 !important;
}

.project-details-page .details-right-area .case-whatsapp:hover {
  color: #218556;
}

.project-details-page .details-right-area button:focus-visible,
.project-details-page .details-right-area a:focus-visible,
.project-details-page .details-right-area .cc-selector input:focus-visible + .payment-item {
  outline: 2px solid #1f94d1;
  outline-offset: 3px;
}

@media (min-width: 992px) and (min-height: 1000px) {
  .project-details-page .project-donation-column {
    position: sticky;
    top: 100px;
  }
}

@media (max-width: 1199.98px) and (min-width: 992px) {
  .project-details-page .project-details-grid {
    grid-template-columns: minmax(0, 1.8fr) minmax(0, 1fr);
    gap: 24px;
  }

  .project-details-page .details-right-area .widget-post {
    padding: 16px !important;
  }
}

@media (max-width: 991.98px) {
  .project-details-page .project-details-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .project-details-page .project-donation-mobile {
    order: 3;
    margin: 0;
  }

  .project-details-page .project-description {
    order: 4;
  }
}

@media (max-width: 767.98px) {
  .project-details-page ::v-deep .project-details-hero .page-title-area {
    min-height: 160px !important;
    padding: 24px 0;
  }

  .project-details-page ::v-deep .project-details-hero .page-title {
    font-size: 22px;
  }

  .project-details-page .cases-details-area {
    padding-block: 20px 32px !important;
  }

  .project-details-page .cases-details-area > .container {
    padding-inline: 16px;
  }

  .project-details-page .details-left-area {
    gap: 20px;
  }

  .project-details-page .cases-wrapper-box .cases__content,
  .project-details-page .project-description {
    padding: 16px;
  }

  .project-details-page .project-media {
    margin: -16px -16px 20px;
  }

  .project-details-page ::v-deep .project-media .home-main-carousel {
    margin-bottom: 0 !important;
  }

  .project-details-page ::v-deep .project-media .owl-nav {
    bottom: 16px !important;
  }

  .project-details-page .cases-wrapper-box .single-case-details-title {
    font-size: 22px;
    margin-bottom: 12px;
  }

  .project-details-page .project-section-title {
    font-size: 18px;
  }

  .project-details-page .project-financial-summary > * {
    padding-inline: 4px;
    font-size: 11px !important;
  }

  .project-details-page .project-financial-summary strong,
  .project-details-page .project-financial-summary .funding span {
    font-size: 13px !important;
  }

  .project-details-page .details-right-area .widget-post {
    padding: 16px !important;
  }
}
</style>
